import React, { ReactElement } from "react";
import { Link } from "react-router";

interface IServiceComponentProps {
    delay: number;
    icon: string;
    // subTitle: ReactElement;
    description: string;
    title: string;
    route: string;
}

export const ServiceComponent: React.FC<IServiceComponentProps> = (
    props: IServiceComponentProps
) => {
    const { delay, icon, description, title, route } = props;

    return (
        <div
            className="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay={delay}
        >
            <div className="service-item  position-relative">
                <div className="gradient-bg icon " >
                    <i className={`bi bi-${icon} `}></i>
                </div>
                <h3>{title}</h3>
                <p>
                    {description?.length > 250
                        ? `${description.substring(0, 250)}...`
                        : description}
                </p>
                <div className="mt-4">
                    <Link to={route}>
                        <button className="button-type-1 gradient-bg">
                            Read More &nbsp;&nbsp;{" "}
                            <i className="bi bi-arrow-right"></i>
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};
